module.exports = __webpack_public_path__ + "media/39.7c99fa47.mp3";